/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsSaveTimeClockGroupRequest,
  FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTimeClockGroups = () => {
/**
 * @summary All groups of the tenant, active and inactive.
 */
const getApiV1TimeclockGroups = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto[]>(
      {url: `/api/v1/timeclock/groups`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Create a group.
 */
const postApiV1TimeclockGroups = (
    facilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsSaveTimeClockGroupRequest: FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsSaveTimeClockGroupRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto>(
      {url: `/api/v1/timeclock/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsSaveTimeClockGroupRequest
    },
      options);
    }
  /**
 * @summary One group.
 */
const getApiV1TimeclockGroupsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto>(
      {url: `/api/v1/timeclock/groups/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Replace a group (name, active flag, periods). Deactivate with isActive = false.
 */
const putApiV1TimeclockGroupsId = (
    id: string,
    facilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsSaveTimeClockGroupRequest: FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsSaveTimeClockGroupRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsTimeClockGroupDto>(
      {url: `/api/v1/timeclock/groups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningWorkflowsTimeClockGroupsSaveTimeClockGroupRequest
    },
      options);
    }
  return {getApiV1TimeclockGroups,postApiV1TimeclockGroups,getApiV1TimeclockGroupsId,putApiV1TimeclockGroupsId}};
export type GetApiV1TimeclockGroupsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockGroups>['getApiV1TimeclockGroups']>>>
export type PostApiV1TimeclockGroupsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockGroups>['postApiV1TimeclockGroups']>>>
export type GetApiV1TimeclockGroupsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockGroups>['getApiV1TimeclockGroupsId']>>>
export type PutApiV1TimeclockGroupsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockGroups>['putApiV1TimeclockGroupsId']>>>
